import { z } from "zod";

export const DateTimeString_Schema = z.string().regex(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/, "Datetime is expected in YYYY-MM-DD HH:mm:ss format.");
export const DateString_Schema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Date is expected in YYYY-MM-DD format.");

/** Including zero */
export const WholeNumber_Schema = z.number().int().nonnegative();

export const NaturalNumber_Schema = z.number().int().positive();

/**
 * We are ignoring the timezone for now!!!
 */
export const DateTimeObject_Schema = z
  .object({
    date: z.string(),
    timezone: z.string(),
    timezone_type: z.number(),
  })
  .transform((val) => {
    const isoLike = val.date.replace(" ", "T");
    return new Date(isoLike);
  })
  .refine((d) => !isNaN(d.getTime()), { message: "Invalid Date" });

export type DateTimeObject = z.infer<typeof DateTimeObject_Schema>;
